import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { NgbModal, NgbAlert } from '@ng-bootstrap/ng-bootstrap';

export enum buttontypes {
  ok = "ok",
  retrycancel = "retrycancel",
  yesorno = "yesorno"
}

@Component({
  selector: 'error-handler',
  templateUrl: './error-handler.component.html',
  styleUrls: ['./error-handler.component.scss']
})
export class ErrorHandlerComponent implements OnInit {
  @ViewChild('ErrorModal', {static: true}) errorModal: TemplateRef<any>;
  public isInfo: boolean = false;
  public showFullError: boolean = false;
  public errorMessage: string;
  public fullErrorMessage: string|object;
  public errorTitle: string;
  public buttontype: buttontypes;
  public activeNotifications: {message: string}[] = [];

  constructor(private _modalService: NgbModal) { }

  async ngOnInit() {
  }

  public async error(message: string = null, options: {fullmessage?: string|object, title?: string, buttons?: buttontypes} = {}): Promise<boolean> {
    message = message ? message : "We've encountered an error. Please try again and report further failures.";
    this.errorMessage = message;
    this.fullErrorMessage = options.fullmessage ?  options.fullmessage : "";
    this.errorTitle = options.title ?  options.title : "Uh Oh!";
    this.buttontype = options.buttons ? options.buttons : buttontypes.ok;
    this.isInfo = false;
    let resp = await this._modalService.open(this.errorModal, { ariaLabelledBy: 'modal-basic-title'}).result;

    this.clearVars();
    return resp;
  }

  public async info(message: string, options: {title?: string, buttons?: buttontypes} = {}): Promise<boolean> {
    message = message ? message : "";
    this.errorMessage = message;
    this.errorTitle = options.title ?  options.title : "Info";
    this.buttontype = options.buttons ? options.buttons : buttontypes.ok;
    this.isInfo = true;
    let resp = await this._modalService.open(this.errorModal, { ariaLabelledBy: 'modal-basic-title'}).result;

    this.clearVars();
    return resp;
  }

  public notification(message: string){
    let note = {message: message};
    this.activeNotifications.push(note);
  }

  public noteClose(idx) {
    this.activeNotifications.splice(idx, 1);
  }

  public isObject(obj) {
    return typeof(obj) === "object";
  }

  clearVars() {
    this.errorMessage = null;
    this.fullErrorMessage = null;
    this.errorTitle = null;
    this.buttontype = null;
    this.showFullError = false;
    this.isInfo = false;
  }
}
